// Chat configuration types and defaults

export type AgentType = 'main' | 'research';

// NOTE: Keep in sync with apps/api/src/types/index.ts (ProjectAccess)
export interface ProjectAccess {
  name: string;
  mode: 'ro' | 'rw';  // read-only or read-write
}

export interface ChatConfig {
  model: 'gemini-3-flash-preview' | 'gemini-3-pro-preview';
  thinkingLevel: 'none' | 'low' | 'medium' | 'high';
  grounding: boolean;
  temperature?: number;
  agent?: AgentType;
  projects?: ProjectAccess[];  // Projects accessible in sandbox
}

export const DEFAULT_CHAT_CONFIG: ChatConfig = {
  model: 'gemini-3-flash-preview',
  thinkingLevel: 'high',
  grounding: false,
  agent: 'main',
};

export const AVAILABLE_MODELS = [
  { id: 'gemini-3-flash-preview' as const, name: 'Gemini 3 Flash', description: 'Fast & efficient' },
  { id: 'gemini-3-pro-preview' as const, name: 'Gemini 3 Pro', description: 'Most capable' },
];

export const THINKING_LEVELS = [
  { id: 'none' as const, name: 'None', description: 'No reasoning' },
  { id: 'low' as const, name: 'Low', description: 'Quick thinking' },
  { id: 'medium' as const, name: 'Medium', description: 'Balanced' },
  { id: 'high' as const, name: 'High', description: 'Deep reasoning' },
];

export const AVAILABLE_AGENTS = [
  { 
    id: 'main' as const, 
    name: 'VDS Manager', 
    description: 'Full capabilities: projects, docker, code',
    icon: 'terminal'
  },
  { 
    id: 'research' as const, 
    name: 'Research', 
    description: 'Web search, analyze URLs, synthesize info',
    icon: 'search'
  },
];

